import { render, staticRenderFns } from "./LampTreeview.vue?vue&type=template&id=61645e96&scoped=true&"
import script from "./LampTreeview.vue?vue&type=script&lang=js&"
export * from "./LampTreeview.vue?vue&type=script&lang=js&"
import style0 from "./LampTreeview.vue?vue&type=style&index=0&id=61645e96&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61645e96",
  null
  
)

export default component.exports